import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import './AuthWrapperComponent.scss';

export default class AuthWrapperComponent extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * component it's wrapping
         */
        children: PropTypes.node,
        /**
         * the call to action has
         */
        callToActionHash: PropTypes.string.isRequired,
        /**
         * the login trigger string
         */
        loginTrigger: PropTypes.string.isRequired,
        customLoginMessage: PropTypes.string,
    };

    static defaultProps = {};

    render() {
        return (
            <div className="component-CallToAction-AuthWrapperComponent">
                <PageConsumer>
                    {(context) =>
                        context.wrapAuth(
                            this.props.callToActionHash,
                            this.props.children,
                            { login_trigger: this.props.loginTrigger },
                            this.props.customLoginMessage
                        )
                    }
                </PageConsumer>
            </div>
        );
    }
}
